package com.eladfinish.bible.contest.data.common.stringResolver

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.desc.desc

interface IStringResolver {
    fun resolveString(
        stringDesc: StringDesc,
    ): String
}


expect class StringResolver : IStringResolver {
    // TODO: Reduce usages of StringResolver
    @Suppress("unused")
    override fun resolveString(stringDesc: StringDesc): String

    /**
     * Same resolution as [resolveString], but actually awaits the result instead of possibly
     * returning "" — safe to use from any suspend call site. On Android/iOS this is a trivial
     * passthrough (resolution is already instant there); only the web actual behaves any
     * differently (it awaits the same background fetch [resolveString] merely kicks off).
     */
    suspend fun resolveStringSuspending(stringDesc: StringDesc): String
}

fun StringResolver.resolveString(stringResource: StringResource): String {
    return resolveString(stringDesc = stringResource.desc())
}

suspend fun StringResolver.resolveStringSuspending(stringResource: StringResource): String {
    return resolveStringSuspending(stringDesc = stringResource.desc())
}
